module.exports = __webpack_public_path__ + "img/hero-dropdown-search-hyundai.14755600.png";